<template>
  <div class="sevice-notice">
    <h2 class="sevice-notice-title f20 main-cl bold flex items-center justify-between"
    >
      <div v-if="showMobileComponent" class="flex">
        <icon icon-name="icon-gonggao" class="notice-icon"/>
        <span class="sevice-notice-title_label">服务公告</span>
      </div>
      <p v-else>服务公告</p>
      <router-link class="more-link f14 weight-normal block" to="/notice">
        更多>
      </router-link>
    </h2>
    <div class="">
      <slider ref="slider">
        <slideritem @tap="tapSlider" v-for="(item, index) in newList" :key="index">
          <div :to="`/notice/detail/${item.id}`" class="notice-item w-full pointer">
            <p class="notice-item-title f16">{{ item.title }}</p>
            <div class="notice-item-desc f14" v-html="item.content"></div>
          </div>
        </slideritem>
        <div slot="loading">loading...</div>
      </slider>
    </div>
  </div>
</template>

<script>
import { slider, slideritem } from "vue-concise-slider";

export default {
  components: {
    slider,
    slideritem,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    newList(){
      return this.list.map(item => ({
        ...item,
        title: item.title.length > 34 ? item.title.substring(0, 30) + '...' : item.title,
        content: item.content.substring(0, 84) + '...',
      }));
    }
  },
  methods:{
    tapSlider({ index }){
      const { $router, list } = this;
      $router.push({
        name: "notice-detail",
        params: {
          id: list[index].id,
        },
      });
    },
  }
};
</script>

<style lang="less" scoped>
/deep/.swiper-container-horizontal > .slider-pagination-bullets{
  bottom: 0;
}
/deep/.slider-container.swiper-container-horizontal .slider-pagination-bullet{
  background: #273033;
}
// 服务公告
.sevice-notice {
  margin-top: 18px;
  padding: .16rem .24rem 0;
  border-top: 1px dashed #c9d1d3;
  @noticeLineHeight: 26px;

  .notice-icon{
    font-size: .28rem;
  }
  .notice-item {
    padding-top: 18px;
    user-select: none;
    white-space: break-spaces;
    line-height: @noticeLineHeight;
    text-align: left;

    &-title {
      color: #000;
      margin-bottom: 12px;
    }
    &-desc {
      color: #666;
      margin-bottom: 20px;
    }
  }
  // 修改轮播图指示器
  /deep/.van-swipe__indicator {
    background: #c9d1d3;
  }
  .more-link {
    color: #878787;
  }
}

@media (max-width: 768px) {
  .sevice-notice {
    padding: 0;
    margin-top: 0;

    &-title {
      padding: 0 0.3rem;
      height: 0.92rem;
      color: #333;
      border-bottom: 1px solid #c9d1d3;

      &_label {
        font-size: 0.32rem;
      }
    }

    .notice-item {
      padding: 0.38rem 0.3rem;
    }
  }
}
</style>
